import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addDiagnosis,
    deleteDiagnosis,
    getDiagnosis,
    searchDiagnosis,
    updateDiagnosis,
} from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function Index() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [diagnosisId, setDiagnosisId] = useState(null);
    const [mainPage, setMainPage] = useState('1');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        diagnosis: '',
    });

    const validationSchema = Yup.object().shape({
        diagnosis: Yup.string().required('Diagnosis is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const getProblems = useSelector((state) => state.master);

    const [formData, setFormData] = useState({
        problem: '',
    });

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleCreateFile = (values, { resetForm }) => {
        dispatch(addDiagnosis(values, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteProblam = (values) => {
        const payload = {
            diagnosisId: diagnosisId,
            diagnosis: values.diagnosis,
        };

        dispatch(updateDiagnosis(payload, limits)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteProblam = () => {
        dispatch(deleteDiagnosis(diagnosisId, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
        };
        setSearchDefault(newSearchParams);
        const queryParams = new URLSearchParams(newSearchParams).toString();
        dispatch(searchDiagnosis(queryParams, newSearchParams.page));
    };

    // const ChangeMainPage = (selected) => {
    //     setMainPage(parseInt(selected.selected) + 1);
    // };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
        };
        setSearchDefault(updatedSearchParams);
        const queryParams = new URLSearchParams(updatedSearchParams).toString();
        dispatch(searchDiagnosis(queryParams, updatedSearchParams.page));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        getProblems?.getDiagnosis?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        if (searchQuery) {
            const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
            const queryParams = new URLSearchParams(updatedSearchParams).toString();
            dispatch(searchDiagnosis(queryParams, updatedSearchParams.page));
        } else {
            dispatch(getDiagnosis(limits));
        }
    }, [mainPage, rowsPerPage]);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Diagnosis
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">Diagnosis List</h3>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Diagnosis Name</Th>
                                <Th className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getProblems?.getDiagnosis?.data?.Diagnosis?.length > 0 ? (
                                getProblems?.getDiagnosis?.data?.Diagnosis?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.diagnosis}</Td>
                                            <Td style={{ minWidth: '200px' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setDiagnosisId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setDiagnosisId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={2} textAlign="center">
                                            Diagnosis Not Found
                                        </Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add problem */}

            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Diagnosis</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleCreateFile}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Diagnosis Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={values.diagnosis}
                                                placeholder="Enter Diagnosis"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                //   onClick={handleCreateFile}
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update problem */}

            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Diagnosis</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteProblam}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Diagnosis Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="diagnosis"
                                                onChange={(e) =>
                                                    setFieldValue('diagnosis', e.target.value)
                                                }
                                                value={values.diagnosis || ''}
                                                placeholder="Enter Diagnosis"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="diagnosis"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete problem */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                {/* <Modal.Header closeButton>
                        <Modal.Title>Delete Problem</Modal.Title>
                    </Modal.Header> */}

                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteProblam}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
